import React from "react";
import { useParams } from "react-router";

import SegmentForm from "./SegmentForm";
import useSegmentActions from "../hooks/useSegmentActions";
import useFirebaseSegment from "../hooks/useFirebaseSegment";

const SegmentEditPage = () => {
  const { editSegment } = useSegmentActions();
  const { id } = useParams();

  const segment = useFirebaseSegment(id!);

  const handleSubmit = (formValues: any) => {
    editSegment(id!, formValues);
  };

  if (!segment) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <div className="border rounded-lg overflow-hidden">
        <h2 className="text-xl font-semibold px-4 py-3 bg-muted">
          Edit Segment
        </h2>
        <div className="p-4">
          <SegmentForm onSubmit={handleSubmit} initialValues={segment} />
        </div>
      </div>
    </>
  );
};

export default SegmentEditPage;
